import '../../style/bitmovin/index.scss'
import { TSubPlayerProps } from '../../types'

export default function PlayerBitmovin(props: TSubPlayerProps) {
  const Player = require('./PlayerBitmovinDynamic').default
  return <Player {...props} />
}
